import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './AppRoot';
import reportWebVitals from './reportWebVitals';
import './App.css';
import { installFrontendErrorCapture } from './services/frontendMonitoring';
import ErrorBoundary from './components/ErrorBoundary';

installFrontendErrorCapture();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
